
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiHeavyRainShowersNight as ObiHeavyRainShowersNightElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-heavy-rain-showers-night.js';
 
 
 

 
 export const ObiHeavyRainShowersNight = createComponent({
   react: React,
   tagName: 'obi-heavy-rain-showers-night',
   elementClass: ObiHeavyRainShowersNightElement,
   events: {
     
   }
  });
 
 